

// 新协议
function kkmhhybrid_upload_image (opt = {}, callback) {
  hybrid({
    hybridParam: {
        schema: "kkmhhybrid",
        tagname: "upload_image",
    },
    param: {
      ...opt
    },
    on: true,
    callback: function (res) {
      let obj = {}
      if (res.code === 200) {
        const data = res.data
        // android 单文件上传需处理
        if (data.status === 0) {
          obj.key = data.key
          obj.list = []
          obj.list.push({
            ...data
          })
        } else {
          obj = {...data}
        }
        callback && callback(obj);
      } else {
        callback && callback(res)
      }
    }
  });
}




/**
 * 获取设备信息<br>
 * kkmhhybrid://upload_image，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=180060196}<br>
 * @param {Object} opt 参数对象
 * @param {srting} opt.key  网页端识别key
 * @param {int} opt.size 单张图片(视频)上限 字节
 * @param {Array} opt.type 允许选取的图片(视频)格式
 * @param {int} opt.width 图片宽度上限
 * @param {string} opt.space 七牛云空间标识
 * @param {int} opt.media_count 允许选图片(或者视频)的数量
 * @param {boolean} opt.need_thumb_base64 是否需要缩略图
 * @param {string} opt.wh_scale 图片裁剪比例-宽高比（选择数量为1张图时生效）
 * @param {int} opt.album_type 相册类型
 * @param {int} opt.least_width 图片最小宽度
 * @param {int} opt.height 图片最大高度（默认9999）
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置），客户端版本小于该值使用旧协议，其余使用新协议
 */
function upload_image (opt = {}, criticalAppVersion) {
  const callback = opt.callback
  delete opt.callback
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion); 
  if (allow) {
    // 新协议
    // 校验
    const err = []
    if (!opt.key) {
      err.push({key: 'key', error: '缺少必填项key'})
    }
    if (!opt.size) {
      err.push({key: 'size', error: '缺少必填项size'})
    }
    if (!opt.type) {
      err.push({key: 'type', error: '缺少必填项type'})
    }
    if (!opt.width) {
      err.push({key: 'width', error: '缺少必填项width'})
    }
    if (!opt.space) {
      err.push({key: 'space', error: '缺少必填项space'})
    }
    if (err.length) {
      console.error(`错误信息===>${JSON.stringify(err)}`)
      return
    }
    kkmhhybrid_upload_image(opt, callback)
  } else {
    console.log('无老协议')
  }
}

export default upload_image;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/upload_image/index.js